import logoBlack from "../../assets/logo/logo-black.png";

const Footer = () => {
  return (
    <footer className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-12 md:py-20 bg-stone-400">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-12 md:gap-20">
        <div>
          <img
            src={logoBlack}
            alt="Parsley Logo"
            className="md:w-52 w-28 h-auto"
          />
        </div>

        <div className="w-full border-t border-black pt-8 flex flex-col items-center gap-1">
          <p className="text-sm">© 2025 ParsleyCT</p>
          <p className="text-sm">
            Powered by{" "}
            <a
              href="https://www.symantriq.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold"
            >
              Symantriq
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
